/**
 * カウンセリングモーダル
 *
 * 商品のカートボタン押下時に、販売元に紐づくカウンセリンググループに基づき
 * 肌の安全性確認モーダルを表示する。
 *
 * ロジック:
 * 1. brands メタオブジェクトから販売元に一致するエントリを取得
 * 2. counselling_group のハンドルが localStorage にあればスキップ
 * 3. カウンセリングモーダル表示 → チェック結果に応じて3パターンに分岐
 */
(function () {
  'use strict';

  // ローカルストレージのキー
  const STORAGE_KEY = 'cm_counselling_completed';

  // --- DOM参照 ---
  const data_element = document.getElementById('cm-counselling-data');
  if (!data_element) return;

  let counselling_data;
  try {
    counselling_data = JSON.parse(data_element.textContent);
  } catch (e) {
    console.error('カウンセリングデータのパースに失敗', e);
    return;
  }

  if (!counselling_data || !counselling_data.handle) return;

  const overlay = document.getElementById('cmCounsellingOverlay');
  const screen_check = document.getElementById('cmCounsellingCheck');
  const screen_success = document.getElementById('cmCounsellingSuccess');
  const screen_caution = document.getElementById('cmCounsellingCaution');
  const screen_denied = document.getElementById('cmCounsellingDenied');

  // ボタン参照
  const btn_reset = document.getElementById('cmCounsellingReset');
  const btn_next = document.getElementById('cmCounsellingNext');
  const btn_continue = document.getElementById('cmCounsellingContinue');
  const btn_confirm_add = document.getElementById('cmCounsellingConfirmAdd');
  const btn_retry = document.getElementById('cmCounsellingRetry');
  const btn_close = document.querySelectorAll('.js-modal-close');
  const btn_chat = document.getElementById('cmCounsellingChat');

  if (!overlay) return;

  // チャットURLを設定
  if (btn_chat && counselling_data.chatUrl) {
    btn_chat.href = counselling_data.chatUrl;
  }

  // --- 保留中のフォーム参照 ---
  let pending_form = null;
  let pending_submit_button = null;

  // --- localStorage操作 ---

  /**
   * 完了済みカウンセリングのハンドル一覧を取得
   * @returns {Array<string>}
   */
  function getCompletedHandles() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  /**
   * カウンセリング完了ハンドルを保存
   * @param {string} handle
   */
  function saveCompletedHandle(handle) {
    const handles = getCompletedHandles();
    if (!handles.includes(handle)) {
      handles.push(handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    }
  }

  /**
   * 指定ハンドルが完了済みか判定
   * @param {string} handle
   * @returns {boolean}
   */
  function isCompleted(handle) {
    return getCompletedHandles().includes(handle);
  }

  // --- 画面表示制御 ---

  /**
   * 全画面を非表示にする
   */
  function hideAllScreens() {
    [screen_check, screen_success, screen_caution, screen_denied].forEach(function (screen) {
      if (screen) screen.style.display = 'none';
    });
  }

  /**
   * 指定画面を表示する
   * @param {HTMLElement} screen
   */
  function showScreen(screen) {
    hideAllScreens();
    if (screen) screen.style.display = '';
  }

  /**
   * モーダルを開く
   */
  function openModal() {
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  /**
   * モーダルを閉じる
   */
  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetForm();
  }

  /**
   * チェックボックスをすべてリセットする
   */
  function resetCheckboxes() {
    const checkboxes = document.querySelectorAll('.cm-counselling-modal__checkbox');
    checkboxes.forEach(function (cb) {
      cb.checked = false;
    });
  }

  /**
   * フォーム状態をリセットする
   */
  function resetForm() {
    pending_form = null;
    if (pending_submit_button) {
      pending_submit_button.classList.remove('loading');
      pending_submit_button.removeAttribute('aria-disabled');
      const spinner = pending_submit_button.closest('product-form')?.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
    pending_submit_button = null;
  }

  // --- カート追加処理 ---

  /**
   * 保留中のフォームでカートに追加する
   * @param {Function} callback 完了後コールバック
   */
  function addToCart(callback) {
    if (!pending_form) {
      if (callback) callback(false);
      return;
    }

    const product_form_element = pending_form.closest('product-form');
    const cart_element = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const form_data = new FormData(pending_form);
    if (cart_element) {
      form_data.append(
        'sections',
        cart_element.getSectionsToRender().map(function (section) { return section.id; })
      );
      form_data.append('sections_url', window.location.pathname);
      cart_element.setActiveElement(document.activeElement);
    }
    config.body = form_data;

    fetch(routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          // エラー処理
          console.error('カート追加エラー:', response.description);
          if (callback) callback(false);
          return;
        }

        // カート更新イベント発行
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'counselling-modal',
            productVariantId: form_data.get('id'),
            cartData: response,
          });
        }

        // カートドロワーの内容を更新
        if (cart_element && !response.status) {
          cart_element.renderContents(response);
        }

        if (callback) callback(true);
      })
      .catch(function (e) {
        console.error('カート追加エラー:', e);
        if (callback) callback(false);
      })
      .finally(function () {
        if (pending_submit_button) {
          pending_submit_button.classList.remove('loading');
          pending_submit_button.removeAttribute('aria-disabled');
          const spinner = pending_submit_button.closest('product-form')?.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
          if (cart_element && cart_element.classList.contains('is-empty')) {
            cart_element.classList.remove('is-empty');
          }
        }
      });
  }

  // --- イベントハンドラ ---

  // product-form のsubmitをインターセプト
  document.addEventListener('submit', function (e) {
    const product_form = e.target.closest('product-form');
    if (!product_form) return;

    const form = product_form.querySelector('form');
    if (!form) return;

    // カウンセリング完了済みならスキップ
    if (isCompleted(counselling_data.handle)) return;

    // フォーム送信をキャンセルし、モーダルを表示
    e.preventDefault();
    e.stopImmediatePropagation();

    // フォーム参照を保存
    pending_form = form;
    pending_submit_button = product_form.querySelector('[type="submit"]');

    // ローディング状態をセット
    if (pending_submit_button) {
      pending_submit_button.setAttribute('aria-disabled', 'true');
      pending_submit_button.classList.add('loading');
      const spinner = product_form.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    }

    // チェック画面を表示
    resetCheckboxes();
    showScreen(screen_check);
    openModal();

    // ローディング状態を解除（モーダルが表示されるため）
    setTimeout(function () {
      if (pending_submit_button) {
        pending_submit_button.classList.remove('loading');
        pending_submit_button.removeAttribute('aria-disabled');
        const spinner = product_form.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    }, 300);
  }, true); // captureフェーズで先にキャッチ

  // やり直すボタン
  if (btn_reset) {
    btn_reset.addEventListener('click', function () {
      resetCheckboxes();
    });
  }

  // 次へ進むボタン
  if (btn_next) {
    btn_next.addEventListener('click', function () {
      const checkboxes = document.querySelectorAll('.cm-counselling-modal__checkbox');

      // 必須・任意チェックボックスの未チェック数をカウント
      let required_unchecked = 0;
      let optional_unchecked = 0;
      let has_required = false;

      checkboxes.forEach(function (cb) {
        const is_required = cb.hasAttribute('data-required');
        if (is_required) {
          has_required = true;
          if (!cb.checked) required_unchecked++;
        } else {
          if (!cb.checked) optional_unchecked++;
        }
      });

      if (has_required) {
        // 必須項目が存在する場合: 必須/任意で分岐
        if (required_unchecked > 0) {
          // 必須項目が1つでも未チェック → 購入不可
          showScreen(screen_denied);
        } else if (optional_unchecked > 0) {
          // 必須は全チェック、任意のいずれかが未チェック → 注意喚起
          showScreen(screen_caution);
        } else {
          // 全てチェック済み → カート追加 → 購入可
          addToCart(function (success) {
            if (success) {
              saveCompletedHandle(counselling_data.handle);
              showScreen(screen_success);
            }
          });
        }
      } else {
        // 必須項目が存在しない場合: 従来ロジック（全数ベース）
        let unchecked_count = 0;
        checkboxes.forEach(function (cb) {
          if (!cb.checked) unchecked_count++;
        });

        if (unchecked_count === 0) {
          addToCart(function (success) {
            if (success) {
              saveCompletedHandle(counselling_data.handle);
              showScreen(screen_success);
            }
          });
        } else if (unchecked_count === 1) {
          showScreen(screen_caution);
        } else {
          showScreen(screen_denied);
        }
      }
    });
  }

  // 買い物を続けるボタン（購入可モーダル）
  if (btn_continue) {
    btn_continue.addEventListener('click', function () {
      closeModal();
    });
  }

  // 確認してカートに入れるボタン（注意喚起モーダル）
  if (btn_confirm_add) {
    btn_confirm_add.addEventListener('click', function () {
      addToCart(function (success) {
        if (success) {
          saveCompletedHandle(counselling_data.handle);
          showScreen(screen_success);
        }
      });
    });
  }

  // もう一度カウンセリングするボタン（購入不可モーダル）
  if (btn_retry) {
    btn_retry.addEventListener('click', function () {
      resetCheckboxes();
      showScreen(screen_check);
    });
  }

  // この画面を閉じるボタン（購入不可モーダル）
  if (btn_close != null) {
    btn_close.forEach((elm)=>{
      elm.addEventListener('click', function () {
        closeModal();
      });
    });
  }

  // オーバーレイクリックでモーダルを閉じる
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      closeModal();
    }
  });

  // ESCキーでモーダルを閉じる
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
})();
